import * as VueGoogleMaps from 'vue3-google-map'
import { appConfig } from 'src/constants'

export default async ({ app }) => {
  app.use(VueGoogleMaps, {
    load: {
      key: appConfig.GOOGLE_MAP_API_KEY,
    },
  })
}
